export const SWITCH_MODE = "SWITCH_MODE";
export const UPDATE_MODE = "UPDATE_MODE";
